import { Label } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Menu,
  MenuItem,
  Typography,
  useTheme,
  alpha,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { InputAdornment, IconButton, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { font } from "../../styles/font";
import { useApplicationContext } from "../../context/ApplicationContext";
import AddUpdateLabelDialog from "../dialog/AddUpdatelabelDialog";
import { ModulePath, Severity } from "../../constant/ApplicationVariables";
import { useNavigate } from "react-router-dom";
import {
  addLabel_API,
  getLabelList_API,
} from "../../api/controller/SettingsController";
import useErrorHandler from "../../api/errorHandler/useErrorHandler";
import { HttpStatusCode } from "axios";
import { Trans, useTranslation } from "react-i18next";

export default function LabelButton({
  selectedList,
  handleApply,
  handleClose,
  disabled
}) {
  const {
    labelList,
    setLabelList,
    activeProject,
    handleSnackbar,
    setActiveConfiguration,
  } = useApplicationContext();

  const theme = useTheme();
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { i18n } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [openLabelDialog, setOpenLabelDialog] = useState(false);

  const [labelAnchorEl, setLabelAnchorEl] = useState(null);
  const [selectedLabels, setSelectedLabels] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [isLabelEditMode, setIsLabelEditMode] = useState(false);
  const [currentLabelData, setCurrentLabelData] = useState(null);
  const [labelData, setLabelData] = useState({
    name: "",
    color: "#FF5733",
  });

  const handleToggleLabelPopup = (e) => {
    e && e.stopPropagation();

    if (!labelAnchorEl) {
      setLabelAnchorEl(e.currentTarget);
    } else {
      setLabelAnchorEl(null);
    }
  };

  const handleChangeLabel = (label) => {
    let list = selectedLabels ? [...selectedLabels] : [];

    const index = list?.findIndex((item) => item?.name === label?.name);

    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(label);
    }

    setSelectedLabels(list);
  };

  const handleOpenLabelAddUpdate_Dialog = (isEdit, item) => {
    setIsLabelEditMode(isEdit);
    setOpenLabelDialog(true);

    if (item && isEdit) {
      setCurrentLabelData(item);
      setLabelData({
        name: item?.name,
        color: item?.colorCode,
      });
    }
  };

  const handleLabelUpdate = () => {
    handleApply(selectedLabels);

    setTimeout(() => {
      handleToggleLabelPopup();
      setSearchText("");
    }, 1100);
  };

  const handleCloseDialog = () => {
    setOpenLabelDialog(false);
    setIsLabelEditMode(false);
    setCurrentLabelData(null);

    setLabelData({
      name: "",
      color: "#FF5733",
    });
  };

  const handleGetList = async () => {
    try {
      setLoading(true);

      let body = {
        name: activeProject?.name,
      };

      let query = new URLSearchParams(body).toString();

      const response = await getLabelList_API(query);

      console.log(response, " response in updateprofile");

      if (response) {
        errorHandler(response, setLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setLabelList(response.data);
      }
    } catch (error) {
      console.log(error, error?.message, "login errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const handleAddlabel = async () => {
    try {
      setLoading(true);

      let body = {
        name: searchText,
        projectName: activeProject?.name,
      };

      const response = await addLabel_API(body);

      console.log(response, " response in updateprofile");

      if (response) {
        errorHandler(response, setLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        handleCloseDialog();
        handleGetList();
        setSearchText("");

        handleSnackbar(response?.data?.message, Severity.success);
      }
    } catch (error) {
      console.log(error, error?.message, "login errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  
  const handleClickLabelButton = () => {
    setActiveConfiguration({ value: "Labels" });
    navigate(ModulePath.configuration);
  };

  useEffect(() => {
    setSelectedLabels(selectedList);
  }, [selectedList]);

  const filteredLabels = labelList?.filter((label) =>
    label?.name?.toLowerCase()?.includes(searchText?.toLowerCase())
  );

  return (
    <Box>
      <Button
        size="small"
        variant="outlined"
        startIcon={<Label />}
        disabled={disabled}
        sx={{ background: labelAnchorEl ? theme.palette.highlight.main : "" }}
        onClick={handleToggleLabelPopup}
      >
        <Trans i18nKey={"templateCommon.labelsText"} />
      </Button>

      {/* add / update dialog */}
      <AddUpdateLabelDialog
        open={openLabelDialog}
        data={currentLabelData}
        isEdit={isLabelEditMode}
        handleClose={handleCloseDialog}
      />

      {/* label list */}
      <Menu
        id="label-list"
        open={Boolean(labelAnchorEl)}
        anchorEl={labelAnchorEl}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              backgroundColor: theme.palette.background.paper,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                left: 14,
                width: 10,
                height: 10,
                bgcolor: theme.palette.background.paper,
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        onClose={handleToggleLabelPopup}
      >
        <Box className="flex flex-col px-2 py-2">
          {/* header */}
          <Box className="flex flex-col gap-2 px-4 py-2 border-b" sx={{ borderColor: theme.palette.divider }}>
            <Typography fontSize={font.size.fs_5} color="textPrimary">
              <Trans i18nKey={"templateCommon.labelsText"} />
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: "12px",
                overflow: "hidden",
                background: theme.palette.background.paper,
                height: "40px",
              }}
            >
              {/* Input field */}
              <InputBase
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search or create label..."
                sx={{
                  flex: 1,
                  fontSize: font.size.fs_5,
                  px: 2,
                  color: theme.palette.text.primary,
                }}
              />

              {/* Search button */}
              <Box
                sx={{
                  background: theme.palette.primary.main,
                  width: "45px",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  "&:hover": { 
                    background: theme.palette.primary.dark 
                  },
                }}
                onClick={handleAddlabel}
              >
                <SearchIcon sx={{ 
                  color: theme.palette.primary.contrastText,
                  fontSize: 20 
                }} />
              </Box>
            </Box>
          </Box>

          {/* body */}
          <Box className="flex flex-col px-2 py-2 relative max-h-[40vh] overflow-y-auto">
            {loading && (
              <Box className="flex-1 flex items-center justify-center absolute inset-0 backdrop-blur-sm bg-white rounded-lg bg-opacity-80"
                sx={{ 
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)',
                  zIndex: 1 
                }}
              >
                <CircularProgress size={20} />
              </Box>
            )}

            {filteredLabels?.length === 0 && !searchText ? (
              <Typography
                fontSize={font.size.fs_5}
                color="textSecondary"
                className="px-4 py-2"
              >
                No labels found
              </Typography>
            ) : (
              filteredLabels?.map((label, index) => (
                <MenuItem key={index} sx={{ padding: 0 }}>
                  <Box className="flex-1 flex items-center gap-2 w-full px-2 py-1">
                    <Checkbox
                      size="small"
                      checked={selectedLabels?.some(
                        (selectedLabel) => selectedLabel?.name === label?.name
                      )}
                      onChange={() => handleChangeLabel(label)}
                      sx={{
                        color: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)',
                        '&.Mui-checked': {
                          color: theme.palette.primary.main,
                        }
                      }}
                    />
                    {/* Keep original badge icon style */}
                    <Label sx={{ color: label?.colorCode }} />
                    <Typography fontSize={font.size.fs_5} color="textPrimary">
                      {label?.name}
                    </Typography>
                  </Box>
                </MenuItem>
              ))
            )}
          </Box>

          {/* footer */}
          <Box className="flex flex-col gap-4 px-4 py-2 border-t" sx={{ borderColor: theme.palette.divider }}>
            {filteredLabels?.length === 0 && searchText ? (
              // CASE B: Show Create Button when searching and no labels found
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleAddlabel}
                sx={{
                  textTransform: 'none',
                  background: theme.palette.primary.main,
                  '&:hover': {
                    background: theme.palette.primary.dark,
                  }
                }}
              >
                Create "{searchText}"
              </Button>
            ) : (
              // CASE A: Show Apply Button when there are labels
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleLabelUpdate}
                sx={{
                  textTransform: 'none',
                  background: theme.palette.primary.main,
                  '&:hover': {
                    background: theme.palette.primary.dark,
                  }
                }}
              >
                Apply
              </Button>
            )}

            {/* Manage labels always visible */}
            <Button
              size="small"
              variant="text"
              sx={{ 
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.1),
                }
              }}
              fullWidth
              onClick={handleClickLabelButton}
            >
              Manage Labels
            </Button>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
}